import { render, staticRenderFns } from "./social-accounts.vue?vue&type=template&id=6bdcbc64&"
import script from "./social-accounts.vue?vue&type=script&lang=js&"
export * from "./social-accounts.vue?vue&type=script&lang=js&"
import style0 from "./social-accounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports